/**
 * How an asset type name is stored: spacing collapsed, upper case ("Bus  adapter " → "BUS ADAPTER"). Django does the
 * same (canonical_asset_type_name) and refuses a name that differs from an existing one only in case, so the forms
 * show and send the stored spelling.
 * @param {string} name
 * @returns {string}
 */
export const canonicalAssetTypeName = (name) => String(name || "").trim().replace(/\s+/g, " ").toUpperCase();
